import { FileQuestion } from 'lucide-react';

import { IrregularidadeCell } from '@/modulos/operacao/comum/IrregularidadeCell';
import { STATUS_TONE } from '@/nucleo/statusBadgeTokens';
import { Badge } from '@/ui/base/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui/base/tooltip';

/**
 * A coluna "Irregularidade" com a documentação da J-05.
 *
 * As validades são as aprovadas pelo DTP (`recurso_documento_decisoes`), não as
 * colunas da 0002. Cadastro sem nenhum documento aprovado NÃO É "Regular": o selo
 * verde diria "documentos em dia" de quem nunca teve documento analisado — a
 * mesma afirmação sem apuração que a coluna `Saúde` evita. Ele ganha selo neutro
 * próprio.
 *
 * Quem não lê a documentação nem vê a coluna (a tela não a monta).
 */
export function IrregularidadeDaDocumentacao({
  validades,
  situacao,
  semVinculo,
}: {
  validades: readonly string[];
  situacao: string;
  semVinculo?: boolean;
}) {
  if (validades.length === 0) {
    return (
      <TooltipProvider delayDuration={150}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge
              variant="outline"
              className={`cursor-help gap-1 font-medium ${STATUS_TONE.neutral}`}
            >
              <FileQuestion className="h-3 w-3" aria-hidden="true" />
              Sem documento aprovado
            </Badge>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-xs text-xs">
            <p className="text-muted-foreground">
              Nenhum documento deste cadastro tem validade aprovada na análise do DTP. Não dá para
              dizer se está em dia.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  return <IrregularidadeCell validades={validades} situacao={situacao} semVinculo={semVinculo} />;
}
